import React, { useEffect, useState } from "react";
import StaffShell from "@/components/layout/StaffShell";
import { staffApi, formatApiError, formatBranchMoney } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { toast } from "sonner";
import EmployeeCommissionReport from "./reports/EmployeeCommissionReport";
import CommissionRepairTools from "./reports/CommissionRepairTools";
import AssistantRepairTools from "./reports/AssistantRepairTools";

export default function BrandReports() {
  const { staff } = useAuth();
  const amOwner = Boolean(
    staff && (staff.is_owner || staff.role_detail?.is_owner),
  );
  const [summary, setSummary] = useState(null);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    Promise.all([
      staffApi.get("/reports/brand/summary"),
      staffApi.get("/branches"),
    ]).then(([r, b]) => {
      setSummary(r.data);
      setBranches(b.data);
    }).catch((err) => toast.error(formatApiError(err)));
  }, []);

  const branchById = Object.fromEntries(branches.map((b) => [b.id, b]));

  return (
    <StaffShell context="brand">
      <h1 className="text-2xl font-semibold mb-6">Brand Reports</h1>
      <Tabs defaultValue="by-location">
        <TabsList>
          <TabsTrigger value="accounting" data-testid="rep-tab-accounting">Accounting</TabsTrigger>
          <TabsTrigger value="marketing" data-testid="rep-tab-marketing">Marketing</TabsTrigger>
          <TabsTrigger value="admin" data-testid="rep-tab-admin">Administration</TabsTrigger>
          <TabsTrigger value="by-location" data-testid="rep-tab-by-location">By Location</TabsTrigger>
        </TabsList>

        <TabsContent value="by-location" className="mt-4">
          <Card className="rounded-lg">
            <CardContent className="p-0">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Location</TableHead>
                    <TableHead className="text-right">Revenue</TableHead>
                    <TableHead className="text-right">Orders</TableHead>
                    <TableHead className="text-right">Appointments</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {(summary?.branches || []).map((b) => (
                    <TableRow key={b.branch_id} data-testid={`rep-row-${b.branch.toLowerCase()}`}>
                      <TableCell className="font-medium">{b.branch}</TableCell>
                      <TableCell className="text-right">{formatBranchMoney(branchById[b.branch_id], b.revenue)}</TableCell>
                      <TableCell className="text-right">{b.orders}</TableCell>
                      <TableCell className="text-right">{b.appointments}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="accounting" className="mt-4 space-y-6">
          <EmployeeCommissionReport />
          {amOwner && <CommissionRepairTools />}
          {amOwner && <AssistantRepairTools />}
        </TabsContent>
        <TabsContent value="marketing" className="mt-4"><Card className="rounded-lg"><CardContent className="p-8 text-sm text-muted-foreground">Marketing reports coming next: booking source, retention, referral performance.</CardContent></Card></TabsContent>
        <TabsContent value="admin" className="mt-4"><Card className="rounded-lg"><CardContent className="p-8 text-sm text-muted-foreground">Administration reports coming next: staff utilization, audit trail, security events.</CardContent></Card></TabsContent>
      </Tabs>
    </StaffShell>
  );
}
